"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadQuery = void 0;
var ReadQuery = /** @class */ (function () {
    function ReadQuery(_a) {
        var dbModule = _a.dbModule, dbType = _a.dbType, dbCollection = _a.dbCollection, dbEndpoint = _a.dbEndpoint, dbAPIToken = _a.dbAPIToken, dbUserToken = _a.dbUserToken;
        var _this = this;
        this.dbType = "";
        this.dbCollection = "";
        this.call = function (cond) { return __awaiter(_this, void 0, void 0, function () {
            var database, postBody, respData, dataState, fbData, dataQuery, fbCollection_1, searchQueryExists_1, queryList, sortReq, fbSnapshot, dataList_1, cursor, sortCol, sortReq, fbData, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        database = this;
                        if (!(database.dbType === "mongoServer" ||
                            database.dbType === "fbServer" ||
                            database.dbType === "mondayServer")) return [3 /*break*/, 2];
                        postBody = {};
                        if (this.dbAPIToken)
                            postBody["apiToken"] = this.dbAPIToken;
                        if (this.dbUserToken)
                            postBody["userToken"] = this.dbUserToken;
                        if (cond.stopLimit)
                            postBody["stopLimit"] = cond.stopLimit;
                        //INFO : Get & List Query Server
                        if (cond.type === "get") {
                            postBody["id"] = cond.id;
                        }
                        else {
                            postBody["query"] = cond.query;
                            postBody["aggregate"] = cond.aggregate;
                            postBody["cursor"] = cond.cursor;
                            postBody["limit"] = cond.limit;
                            postBody["sort"] = cond.sort;
                        }
                        return [4 /*yield*/, database.dbModule.post(database.dbEndpoint + "/".concat(database.dbCollection, "/").concat(cond.type), postBody)];
                    case 1:
                        respData = _b.sent();
                        dataState = {
                            data: respData.data.data,
                        };
                        if (!cond.aggregate && cond.type === "list") {
                            dataState["count"] = respData.data.count;
                        }
                        return [2 /*return*/, dataState];
                    case 2:
                        if (!(database.dbType === "firebase")) return [3 /*break*/, 6];
                        if (!(cond.type === "get")) return [3 /*break*/, 4];
                        fbData = void 0;
                        return [4 /*yield*/, database.dbModule
                                .firestore()
                                .collection(database.dbCollection)
                                .doc(cond.id)
                                .get()];
                    case 3:
                        dataQuery = _b.sent();
                        if (dataQuery.exists()) {
                            fbData = dataQuery.data();
                        }
                        return [2 /*return*/, {
                                data: fbData,
                            }];
                    case 4:
                        if (!(cond.type === "list")) return [3 /*break*/, 6];
                        fbCollection_1 = database.dbModule
                            .firestore()
                            .collection(database.dbCollection);
                        searchQueryExists_1 = "";
                        queryList = (_a = cond.query) !== null && _a !== void 0 ? _a : [];
                        if (queryList && queryList.length > 0) {
                            queryList.map(function (eachQuery) {
                                var _a;
                                var queryId = (_a = eachQuery.queryId) !== null && _a !== void 0 ? _a : "";
                                var value = eachQuery.value;
                                switch (eachQuery.type) {
                                    case "search":
                                        if (eachQuery.searchIds && eachQuery.searchIds.length > 0) {
                                            searchQueryExists_1 = eachQuery.searchIds[0];
                                            fbCollection_1 = fbCollection_1
                                                .orderBy(eachQuery.searchIds[0])
                                                .startAt(value)
                                                .endAt(value + "\uf8ff");
                                        }
                                        break;
                                    case "=":
                                        fbCollection_1 = fbCollection_1.where(queryId, "==", value);
                                        break;
                                    case ">":
                                        fbCollection_1 = fbCollection_1.where(queryId, ">", value);
                                        break;
                                    case "<":
                                        fbCollection_1 = fbCollection_1.where(queryId, "<", value);
                                        break;
                                    case "><":
                                        if (Array.isArray(value) && value.length >= 2) {
                                            fbCollection_1 = fbCollection_1
                                                .where(queryId, ">=", value[0])
                                                .where(queryId, "<=", value[1]);
                                        }
                                        break;
                                    case "in":
                                        fbCollection_1 = fbCollection_1.where(queryId, "in", value);
                                        break;
                                    default:
                                        break;
                                }
                                return null;
                            });
                        }
                        //INFO : Step 2 - Limit
                        if (cond.limit) {
                            fbCollection_1 = fbCollection_1.limit(cond.limit);
                        }
                        else {
                            throw new Error("Invalid Limit Configuration");
                        }
                        //INFO : Step 3 - Sort
                        if (cond.sort) {
                            sortReq = cond.sort;
                            if (searchQueryExists_1 && sortReq.sortId !== searchQueryExists_1) {
                                throw new Error("Invalid Search Sort Configuration");
                            }
                            if (!searchQueryExists_1) {
                                fbCollection_1 = fbCollection_1.orderBy(sortReq.sortId, sortReq.type === "asc" ? "asc" : "desc");
                            }
                        }
                        //INFO : Step 4 - Pagination
                        if (cond.cursor) {
                            fbCollection_1 = fbCollection_1.startAfter(cond.cursor);
                        }
                        return [4 /*yield*/, fbCollection_1.get()];
                    case 5:
                        fbSnapshot = _b.sent();
                        dataList_1 = [];
                        if (fbSnapshot) {
                            fbSnapshot.forEach(function (eachDataDoc) {
                                var eachData = eachDataDoc.data();
                                dataList_1.push(eachData);
                            });
                        }
                        cursor = "";
                        if (dataList_1.length === cond.limit) {
                            sortCol = "id";
                            if (cond.sort) {
                                sortReq = cond.sort;
                                sortCol = sortReq.sortId;
                            }
                            cursor = dataList_1[cond.limit - 1][sortCol];
                        }
                        fbData = {
                            data: dataList_1,
                            count: cursor,
                        };
                        return [2 /*return*/, {
                                data: fbData,
                            }];
                    case 6: return [2 /*return*/, null];
                    case 7:
                        err_1 = _b.sent();
                        throw new Error(err_1);
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        this.dbModule = dbModule;
        this.dbType = dbType;
        this.dbCollection = dbCollection;
        this.dbEndpoint = dbEndpoint;
        this.dbAPIToken = dbAPIToken;
        this.dbUserToken = dbUserToken;
    }
    return ReadQuery;
}());
exports.ReadQuery = ReadQuery;
//# sourceMappingURL=index.js.map